import {Children, PropsWithChildren} from 'react';
import {createPortal} from 'react-dom';
import {InfoBoxType} from './app';

export interface InfoxProps {
  readonly infoBoxType: InfoBoxType | undefined;
}

export function InfoBox({
  infoBoxType,
  children,
}: PropsWithChildren<InfoxProps>) {
  if (!infoBoxType) {
    return null;
  }

  return createPortal(
    <div
      className={
        'absoulte xl:p-30 md:p-30 2xl:p-50 absolute inset-0 bg-black bg-opacity-80 p-10 sm:p-20 lg:p-40'
      }
    >
      {children}
    </div>,
    document.body
  );
}
